import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCopy, FiCheck } = FiIcons;

export default function Gifts({ copy }) {
  const [copied, setCopied] = useState(false);

  const copyAccount = async () => {
    await navigator.clipboard.writeText(copy.account);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <section className="gifts section-shell">
      <div className="gifts-content">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
        <p>{copy.copy}</p>
        <div className="account-box">
          <span>{copy.accountLabel}</span>
          <strong>{copy.account}</strong>
          <button type="button" onClick={copyAccount}>
            <SafeIcon icon={copied ? FiCheck : FiCopy} />
            {copied ? copy.copied : copy.copyButton}
          </button>
        </div>
      </div>
    </section>
  );
}